export const isPdfFileName = (fileName: string): boolean => fileName.toLowerCase().endsWith('.pdf');
